import { Dialog } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect } from 'react';
import IntlTelInput from 'react-intl-tel-input';
import LinearProgress from '@mui/material/LinearProgress';
import 'react-intl-tel-input/dist/main.css';
import { useService } from '~/services/service.base';
import { DialogService } from '~/services/service.dialog';
import { CodeVerification } from '~/views/molecules/code.verification';
import { AlertDialog } from '~/views/molecules/alert.dialog';
import { WrapperService } from '~/services/service.wrapper';
import { GaCategories, GaEvents } from '~/views/enums';

export const SignInDialog: FC = observer(() => {
    const dialogService = useService(DialogService);
    const { signInDialogSrv, alertDialogSrv } = dialogService;
    const wrapperService = useService(WrapperService);
    const { authService } = wrapperService;

    useEffect(() => {
        authService.sendGaEvent({
            category: GaCategories.loginFlow,
            action: GaEvents.loginViewed,
            label: JSON.stringify({ webshop_direct: true }),
        });

        signInDialogSrv.setBtnDisabled(true);

        window.addEventListener('keyup', e => signInDialogSrv.onStepKeyUp(e, alertDialogSrv));

        alertDialogSrv.setData({
            headerText: 'Something went wrong',
            mainText: 'Looks like we could not log you in to the website, please contact support',
            showContactInfo: true,
        });

        const timer = setTimeout(() => {
            const phoneInput = document.getElementById('sign-in-phone');
            if (phoneInput) {
                // @ts-ignore
                phoneInput.setAttribute('maxLength', '10');
            }
        }, 200);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <Dialog open={signInDialogSrv.open} className="hr-modal-dialog">
                <div id="sign-in-modal" className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            {signInDialogSrv.showLoading ? <LinearProgress /> : null}
                            {signInDialogSrv.showStep1 && (
                                <div className="modalContent step1">
                                    <h3>Sign in</h3>
                                    <p>
                                        Please Enter The Phone Number
                                        <br /> With Which You Are Registered At Hard Rock Neverland Casino.
                                    </p>
                                    <div className="sign-in-phone-wrap">
                                        <IntlTelInput
                                            containerClassName="intl-tel-input"
                                            inputClassName="form-control phone-input"
                                            separateDialCode={true}
                                            onlyCountries={['us']}
                                            preferredCountries={['us']}
                                            onPhoneNumberChange={signInDialogSrv.handlePhoneNumberChange}
                                            value={signInDialogSrv.phoneNumber}
                                            fieldId="sign-in-phone"
                                            placeholder="Enter your Phone Number"
                                        />
                                        <div className="phone-eye-wrap" onClick={signInDialogSrv.handlePhoneEyeClick}>
                                            <figure>
                                                <img src="/assets/img/phone-eye.svg" />
                                            </figure>
                                        </div>
                                    </div>
                                    {signInDialogSrv.lastError.description && (
                                        <div className="tel-error-msg">{signInDialogSrv.lastError.description}</div>
                                    )}
                                    <div className="sign-in-btn-wrap">
                                        <button
                                            type="button"
                                            id="sign-in-step1-btn"
                                            onClick={() => signInDialogSrv.handleOpenStep3(alertDialogSrv)}
                                            disabled={signInDialogSrv.btnDisabled}
                                            className="btn"
                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>
                            )}
                            {signInDialogSrv.showStep2 && (
                                <div className="modalContent step2">
                                    <h3>Let’s confirm it’s really you</h3>
                                    <p>Help us secure your account. Please complete the verifications below</p>
                                    <div className="full-phone-wrap">
                                        <p>
                                            Get the code by text message (SMS) at
                                            <br />
                                            <span id="step2-full-phone">{signInDialogSrv.fullNumber}</span>
                                        </p>
                                    </div>
                                    <div className="edit-phone-wrap">
                                        <a href="#" id="edit-phone-link" onClick={signInDialogSrv.handleOpenStep1}>
                                            Edit my number
                                        </a>
                                    </div>
                                    {signInDialogSrv.lastError.description && (
                                        <div className="tel-error-msg">{signInDialogSrv.lastError.description}</div>
                                    )}
                                    <div className="sign-in-btn-wrap">
                                        <button
                                            type="button"
                                            id="sign-in-step2-btn"
                                            className="btn"
                                            onClick={() => signInDialogSrv.handleOpenStep3(alertDialogSrv)}
                                        >
                                            Continue
                                        </button>
                                    </div>
                                </div>
                            )}
                            {signInDialogSrv.showStep3 && (
                                <div className="modalContent step3">
                                    <CodeVerification
                                        onSendVerificationCode={signInDialogSrv.sendVerificationCode}
                                        onEnterVerificationCode={signInDialogSrv.getAuthToken}
                                        showContactInfo={true}
                                    >
                                        We texted your code to
                                        <br />
                                        {signInDialogSrv.fullNumber}
                                        <br />
                                        This code is only valid for 2 minutes
                                    </CodeVerification>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Dialog>
            {alertDialogSrv.open && <AlertDialog error={signInDialogSrv.lastError} showContactInfo={true} />}
        </>
    );
});
